<script>
import Loading from '../../components/loading.vue';

export default {
    name: "login",
    data() {
        return {
            tabs: ['验证码登录', '账号密码登录'],
            tabActiveIndex: 0,
            phone: '',
            code: '',
            password: '',
            isCodeLoading: false,
            countdown: 0,
            time: null,
            isLoading: false,
        };
    },
    computed: {},
    components: {
        Loading
    },
    mounted() {
        
    },
    destroyed() {},
    watch: {},
    methods: {
        // 设置倒计时
        setCountdown() { 
            this.countdown = 59;
            if(this.time) clearInterval(this.time);
            this.time = setInterval(() => {
                this.countdown--;
                if(this.countdown <= 0) clearInterval(this.time);
            }, 1000)
        },
        // 获取验证码
        getCode() { 
            if (this.isCodeLoading) { 
                return;
            }
            if(this.phone.replace(/(^\s*)|(\s*$)/g, "").length == 0){
                this.$refs.phone.focus();
                this.$showToast({ text: '请输入手机号' });
                return false;
            }
            this.isCodeLoading = true;
            this.$store.dispatch('getCode', {
                phone: this.phone,
                type: 2
            }).then((result) => {
                this.isCodeLoading = false;
                if (result.code == 100) {
                    this.setCountdown();
                    this.$showToast({ text: '验证码已发送' });
                } else if (result.code == 101) { 
                    this.$showToast({ text: '验证码发送失败' });
                } else if (result.code == 102) { 
                    this.$showToast({ text: '已发送验证码，请勿重复获取' });
                    this.setCountdown();
                }
            }).catch((err) => {
                this.isCodeLoading = false;
                this.$showToast({ text: '验证码发送失败' });
            });
        },
        // 登录
        submit() { 
            if (this.isLoading) { 
                return;
            }
            if(this.phone.replace(/(^\s*)|(\s*$)/g, "").length == 0){
                this.$refs.phone.focus();
                this.$showToast({ text: '请输入手机号' });
                return false;
            }
            if (this.tabActiveIndex == 0) { 
                if(this.code.replace(/(^\s*)|(\s*$)/g, "").length == 0){
                    this.$refs.code.focus();
                    this.$showToast({ text: '请输入验证码' });
                    return false;
                }
            }
            if (this.tabActiveIndex == 1) { 
                if(this.password.replace(/(^\s*)|(\s*$)/g, "").length == 0){
                    this.$refs.password.focus();
                    this.$showToast({ text: '请输入密码' });
                    return false;
                }
            }
            this.isLoading = true;
            this.$store.dispatch('login', {
                username: this.phone,
                type: this.tabActiveIndex + 1,
                code: this.code,
                password: this.password,
            }).then((result) => {
                this.isLoading = false;
                if (result.code == 100) {
                    localStorage.setItem('token', result.data.token);
                    this.$store.state.userinfo = result.data.userinfo;
                    if (this.$route.query.redirect) {
                        this.$router.replace(this.$route.query.redirect);
                    } else {
                        this.$router.replace('/');
                    }
                } else if (result.code == 101) {
                    this.$showToast({ text: '验证码错误' });
                } else if (result.code == 102) {
                    this.$showToast({ text: '密码错误' });
                } else if (result.code == 103) { 
                    this.$showToast({ text: '登录失败' });
                } else {
                    this.$showToast({ text: '登录失败' });
                }
            }).catch((err) => {
                this.isLoading = false;
                this.$showToast({ text: '登录失败' });
            });
        },
    },
};
</script>

<template>
    <div class="layout_mine flex flex_column justify_center">
        <p class="title">登录</p>
        <div class="form">
            <div class="tabs flex" :data-index="tabActiveIndex">
                <div class="item" :class="{active: tabActiveIndex == index}" v-for="(item, index) in tabs" :key="index" @click="tabActiveIndex = index">{{ item }}</div>
            </div>
            <template v-if="tabActiveIndex == 0">
                <div class="input_group">
                    <input type="tel" placeholder="请输入手机号" ref="phone" v-model="phone" @keyup.enter="submit"/>
                </div>
                <div class="input_group">
                    <input type="text" placeholder="请输入验证码" ref="code" v-model="code" maxlength="6" @keyup.enter="submit"/>
                    <div class="btn btn_code layout_flex_center" v-if="isCodeLoading">
                        <Loading  type="smail"/>
                    </div>
                    <div class="btn btn_code layout_flex_center" v-else-if="countdown > 0">{{ countdown }}s</div>
                    <div class="btn btn_code layout_flex_center" @click="getCode" v-else>获取验证码</div>
                </div>
            </template>
            <template v-if="tabActiveIndex == 1">
                <div class="input_group">
                    <input type="text" placeholder="请输入用户名或手机号" ref="phone" v-model="phone" @keyup.enter="submit"/>
                </div>
                <div class="input_group">
                    <input type="password" placeholder="请输入密码" ref="password" v-model="password" @keyup.enter="submit"/>
                </div>
            </template>
            <div class="input_group">
                <div class="btn layout_flex_center" v-if="isLoading">
                    <Loading  type="smail"/>
                </div>
                <div class="btn layout_flex_center" v-else @click="submit">登录</div>
            </div>
            <p class="tip center">首次访问？<router-link :to="{ path: '/register', query: $route.query }">立即注册</router-link></p>
        </div>
    </div>
</template>

<style scoped lang="scss">
@import '~@/assets/css/mineForm.scss';
</style>